import { Row, Col } from "antd";

import { useCookies } from "react-cookie";

import {
  RenderAnonymous,
  RenderAuthenticated
} from "@seims/shared/src/security";

import { CookieConsentView } from "../common/components/CookieConsentView";
import { AnonymousLayout } from "./AnonymousLayout";
import AuthorizedLayout from "./AuthorizedLayout";
import InstallPrompt from "src/events/components/InstallPrompt";

export const CustomLayout = () => {

  const [cookies] = useCookies(["cookieConsent"]);

  return (
    <div>
      {/* <Tour run={true} tour={tour} />
      <Tour run={run} tour={steps} /> */}

      <RenderAuthenticated>
        <AuthorizedLayout />
      </RenderAuthenticated>

      <RenderAnonymous>
        <AnonymousLayout />
      </RenderAnonymous>
      <InstallPrompt />

      <Row justify={"center"}>
        <Col sm={22} md={10}>
          {!cookies.cookieConsent && <CookieConsentView />}
        </Col>
      </Row>
    </div>
  );
};

export default CustomLayout;
